import React, { useContext } from 'react';
import { appContext } from './appContext';

export function Logo() {
    const currentAppContext = useContext(appContext.context);
    const { customerVersion } = currentAppContext.globalSettings;

    return (
        <img
            src={`/assets/img/${customerVersion}/logos/logo-large.png`}
            title={customerVersion}
            className="logoImage center-block img-responsive logo-large"
        />
    );
}
